import { SINGLE_SELECT_LABEL_SELECTOR } from "./constants";

const syncSelectedLabel = (
  selectElement: HTMLSelectElement,
  dropdownButton: HTMLButtonElement
) => {
  const labelElement = dropdownButton.querySelector<HTMLElement>(
    SINGLE_SELECT_LABEL_SELECTOR
  );
  const selectedOption = selectElement.selectedOptions[0];

  if (!labelElement || !selectedOption) {
    return;
  }

  labelElement.textContent = selectedOption.textContent ?? "";
};

export default syncSelectedLabel;
